module.exports = {
  DEFAULT_AVATAR: require('../images/avatar_default.jpg'),
  risk_normal: {
    HEAD_LEAN: require('../images/posture/normal/head_lean_normal.png'),

    HEAD_SIDESWAY_LEFT: require('../images/posture/normal/head_sideway_left.png'),
    HEAD_SIDESWAY_RIGHT: require('../images/posture/normal/head_sideway_right.png'),
    HEAD_SIDESWAY_NORMAL: require('../images/posture/normal/head_sideway_normal.png'),

    HIGH_LOW_SHOULDER_LEFT: require('../images/posture/normal/high_low_shoulder_left.png'),
    HIGH_LOW_SHOULDER_RIGHT: require('../images/posture/normal/high_low_shoulder_right.png'),
    HIGH_LOW_SHOULDER_NORMAL: require('../images/posture/normal/high_low_shoulder_normal.png'),

    ROUND_SHOULDER: require('../images/posture/normal/round_shoulder_normal.png'),

    SPINE_SIDESWAY_LEFT: require('../images/posture/normal/spine_sideway_left.png'),
    SPINE_SIDESWAY_RIGHT: require('../images/posture/normal/spine_sideway_right.png'),
    SPINE_SIDESWAY_NORMAL: require('../images/posture/normal/spine_sideway_normal.png'),

    PELVIS_LEAN_LEFT: require('../images/posture/normal/pelvis_lean_left.png'),
    PELVIS_LEAN_RIGHT: require('../images/posture/normal/pelvis_lean_right.png'),
    PELVIS_LEAN_NORMAL: require('../images/posture/normal/pelvis_lean_normal.png'),

    LEG_O: require('../images/posture/normal/leg_o_normal.png'),
    LEG_X: require('../images/posture/normal/leg_x_normal.png'),
    KNEE_OVERSTRETCH: require('../images/posture/normal/knee_overstretch_normal.png'),
    LEG_XO: require('../images/posture/normal/leg_xo.png'),
  },
  risk_abnormal: {
    HEAD_LEAN: require('../images/posture/abnormal/head_lean_left.png'),
    HEAD_SIDESWAY_LEFT: require('../images/posture/abnormal/head_sideway_left.png'),
    HEAD_SIDESWAY_RIGHT: require('../images/posture/abnormal/head_sideway_right.png'),
    HIGH_LOW_SHOULDER_LEFT: require('../images/posture/abnormal/high_low_shoulder_left.png'),
    HIGH_LOW_SHOULDER_RIGHT: require('../images/posture/abnormal/high_low_shoulder_right.png'),
    ROUND_SHOULDER: require('../images/posture/abnormal/round_shoulder_left.png'),
    SPINE_SIDESWAY_LEFT: require('../images/posture/abnormal/spine_sideway_left.png'),
    SPINE_SIDESWAY_RIGHT: require('../images/posture/abnormal/spine_sideway_right.png'),
    PELVIS_LEAN_LEFT: require('../images/posture/abnormal/pelvis_lean_left.png'),
    PELVIS_LEAN_RIGHT: require('../images/posture/abnormal/pelvis_lean_right.png'),
    LEG_O: require('../images/posture/abnormal/leg_o_left.png'),
    LEG_X: require('../images/posture/abnormal/leg_x_left.png'),
    KNEE_OVERSTRETCH: require('../images/posture/abnormal/knee_overstretch_left.png'),
    LEG_XO: require('../images/posture/abnormal/leg_xo.png'),
  },
  RISK_ICON: require('../images/risk-icon.png'),
  RISKBAR_ICON: require('../images/posture/riskbar-icon.png'),
  riskbar_arrow: {
    low: require('../images/low.png'),
    middle: require('../images/middle.png'),
    high: require('../images/high.png'),
  },
  bone: {
    face: require('../images/posture/bone/face.png'),
    side: require('../images/posture/bone/side.png'),
    faceBone: require('../images/posture/bone/faceBone.png'),
    sideBone: require('../images/posture/bone/sideBone.png'),
    backBone: require('../images/posture/bone/backBone.png'),
    boneCanvas: require('../images/posture/bone/boneCanvas.png')
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/imgSrc.js